import { useInviteClientModal, useSelectedClient } from '@entities/clients/heplers.ts';
import { useDeleteClientMutation } from '@entities/clients/rtk-query.ts';
import type React from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { MoreHoriz } from '@shared/assets';
import { useWindowWidth } from '@shared/hooks';
import type { Client } from '@shared/types/users';
import { IconButton, MenuDropdown, MenuItem, useCommonMenu } from '@shared/ui';
import { openDialogModal } from '@src/library/redux/modal';

type Props = {
  client: Client;
};

export const ClientMenu: React.FC<Props> = ({ client }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { openInviteModal } = useInviteClientModal();
  const fullname = [client.last_name, client.first_name, client.middle_name].join(' ');
  const windowWidth = useWindowWidth();
  const { onOpen, onClose, setReferenceEl, referenceEl, popperEl, setPopperEl } = useCommonMenu();
  const { clearSelectedClient } = useSelectedClient();
  const { state } = useLocation();

  // const { clients, removeClient } = useClients();

  // console.log('clients:', clients);
  const [deleteClientMutation, { isLoading }] = useDeleteClientMutation();

  const deleteClient = async () => {
    try {
      const response = await deleteClientMutation(client!.id);
      if (!response?.error) {
        if (windowWidth <= 768) {
          navigate(-1);
        } else {
          clearSelectedClient();
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    client && (
      <>
        <IconButton
          key={`IconButton-${client.id}-profile`}
          id={`button-${client.id}-profile`}
          onClick={onOpen}
          ref={setReferenceEl}
          variant="transparent"
        >
          <MoreHoriz />
        </IconButton>
        <MenuDropdown
          id={`${client.id}-profile`}
          referenceEl={referenceEl}
          popperEl={popperEl}
          setPopperEl={setPopperEl}
          key={`MenuDropdown-${client.id}-profile`}
        >
          {!client?.is_registered && (
            <MenuItem
              key={'profile' + client.id + 'Пригласить'}
              onClick={(e) => {
                onClose(e);
                openInviteModal();
              }}
            >
              Пригласить
            </MenuItem>
          )}
          <MenuItem
            key={'profile' + client.id + 'Изменить'}
            onClick={(e) => {
              onClose(e);
              navigate(`/clients/clients/edit/${client.id}`, {
                state: {
                  path: window.location.pathname,
                  prevPath: state && state.path ? state.path : window.location.pathname,
                },
              });
            }}
          >
            Изменить
          </MenuItem>
          {!client.is_registered && (
            <MenuItem
              key={'profile' + client.id + 'Удалить'}
              onClick={(e) => {
                if (isLoading) {
                  return;
                }

                onClose(e);

                dispatch(
                  openDialogModal({
                    title: 'Удаление клиента',
                    text: `Вы действительно хотите удалить ${fullname} из списка клиентов?`,
                    closeToConfirm: true,
                    onRequestClose: true,
                    dinamicHeight: true,
                    confirmText: 'Да',
                    confirm: () => {
                      deleteClient();
                    },
                    declineText: 'Нет',
                    // decline?: () => void,
                    // link?: {
                    // 	url: string,
                    // 	text: string,
                    //  },
                  })
                );
                // clientService.deleteClient(client!.id);
              }}
            >
              Удалить
            </MenuItem>
          )}
        </MenuDropdown>
      </>
    )
  );
};
